import React, { useEffect, useState , useMemo } from "react";
import CustomButton from "../../AppComponent/CustomButton/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import {
  getSideBarfilesActions,
  setThePayslipAcrions,
  setTheoptions,
  setThecountBasedRenders,
  setThePayslipDeleteActions, ///delete
  setDropDownRenders,
  setThePaylipDesignations
} from "../../../Redux/Slice";
import { NavLink } from "react-router-dom";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import "../../../StyleSheet/MainComponent/PaySlip/PaySlip.scss";
import PaySlipCreate from "./PaySlipCreate";
import Select from "react-select";
import Delete from "../../AppComponent/Popup/Delete";
import _ from "lodash";
import DeleteImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-05.svg";
import DownloadImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-27.svg";


const PaySlip = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const [sno, setsno] = useState(0);

  const [RoleCreatePopup, setRoleCreatePopup] = useState(false);
  const [newpages, setNewpage] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [search, setsearch] = useState("");
  const [pageSize, setPageSize] = useState(20);
  const [DeletePOPUP, setDeletePOPUP] = useState(false);
  const [DeleteID, setDeleteID] = useState("");
  const [EditId, setEditID] = useState();

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "",
      label: "ALL",
    },
    {
      value: "1",
      label: "QPMS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);
  const state = useSelector((state) => state);
  const FileterState = {
    status: "",
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);

  const [FState, SetStates] = useState(false);
  const [yearAndMonth, setYearMpnth] = useState();
  const date = new Date();


  const [filterForWhite, setFilters] = useState({ white_collar: 


    state.StateManagementOverallCall.PaySlipDesignations?.value == ""?
    "":
    state.StateManagementOverallCall.PaySlipDesignations?.value == 1 ?
    true:
    false

  });

  // console.log(date.getFullYear(), "date");
  const months =
    date.getMonth() < 10 ? `0${date.getMonth() + 1}` : date.getMonth() +1;
  //var yearAndMonth = `${date.getFullYear()}-${months}`;
  useEffect(() => {
    setYearMpnth(`${date.getFullYear()}-${months}`);
  }, []);

  const [Data, setdata] = useState({
    month: months,
    year: date.getFullYear(),
  });

  ////---- end of the filters
  const [monthYearset, setMonthYear] = useState("");

  ///-----Month and yar based filter
  ////------month and year based filters-------------------------------
  const handleChange = (e) => {
    const inputValue = e.target.value;
    setMonthYear(inputValue);
    setdtPageindex(1);
  
    const months = new Date(inputValue);
    const selectedMonth = String(months.getMonth() + 1).padStart(2, "0"); // Ensures 2-digit format
    const selectedYear = months.getFullYear();
  

    setYearMpnth(`${selectedYear}-${selectedMonth}`);
    // console.log(e.target.value, "weurweydsfsd", selectedmonth);
    setdata({
      ...Data,
      month: selectedMonth,
      year: selectedYear,
    });
  };

  const HandleEMprole = (e) => {
    setdtPageindex(1);

    if (e != null) {

dispatch(setThePaylipDesignations(e))
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else if (e.value == 2) {
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      } else if (e.value == "") {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
         dispatch(setThePaylipDesignations({value:"",label:"ALL"}))
      }
    }
  };

  
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);
  /// console.log(state.NumberCounts, "fsdf");
  const options = [
    { value: state.NumberCounts.Option1, label: "All" },
    { value: state.NumberCounts.Option3, label: "Pending" },
    { value: state.NumberCounts.Option4, label: "Decline" },
    { value: state.NumberCounts.Option5, label: "Approved" },
  ];
  const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  //--------Place---Holder----dispatch======
  useEffect(() => {
    dispatch(setDropDownRenders(""))

    if (state.NumberCounts.namerednder == "") {
      dispatch(setTheoptions(options));
      SetPlace("All");
    }
    if (state.NumberCounts.namerednder == "completed") {
      dispatch(setTheoptions(options[0]));
      SetPlace("Completed");
    }
    if (state.NumberCounts.namerednder == "Decline") {
      dispatch(setTheoptions(options[3]));
      SetPlace("Decline");
    }
    if (state.NumberCounts.namerednder == "Pending") {
      dispatch(setTheoptions(options[2]));
      SetPlace("Pending");
    }
  }, [state.NumberCounts.namerednder]);

  useEffect(() => {
     if(RoleCreatePopup == false){ 
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      selectVal: selectVal,
      white_collar: filterForWhite.white_collar,
      month: Data.month,
      year: Data.year,
    };

    dispatch(setThePayslipAcrions(payload));
  }
  }, [selectVal, filterForWhite, Data, dtpageindex , RoleCreatePopup]);


  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };


  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        const payload = {
          search: e,
          page_size: dtpagesize,
          page: 1,
          selectVal: selectVal,
          white_collar: filterForWhite.white_collar,
          month: Data.month,
          year: Data.year,
        };
        dispatch(setThePayslipAcrions(payload));
      }, 500),
    []
  );


  // -----Search------------------------
  function tochange(e) {
    setsearch(e);
    setdtPageindex(1);
    debouncedSearch(e);
    // if (e.trim() != undefined && e.trim() != "") {
    //   const payload = {
    //     search: e.trim(),
    //     page_size: dtpagesize,
    //     page: 1,
    //     selectVal: selectVal,
    //     white_collar: filterForWhite.white_collar,
    //     month: Data.month,
    //     year: Data.year,
    //   };
    //   dispatch(setThePayslipAcrions(payload));
    // }
    // if (e == "" || search == "") {
    //   const payload = {
    //     search: "",
    //     page_size: dtpagesize,
    //     page: 1,
    //     selectVal: selectVal,
    //     white_collar: filterForWhite.white_collar,
    //     month: Data.month,
    //     year: Data.year,
    //   };
    //   dispatch(setThePayslipAcrions(payload));
    // }
  }


   React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const download = (e) => {
    console.log(e.target.href);
    fetch(e.target.href, {
      method: "GET",
      headers: {},
    })
      .then((response) => {
        response.arrayBuffer().then(function (buffer) {
          const url = window.URL.createObjectURL(new Blob([buffer]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "image.png"); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const columns = useMemo(
    () => [
  {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
          if (
            row.row.original.id != undefined &&
            row.row.original.id != null
          ) {
            const userId = row.row.original.id;
            const lastFourDigits = userId.slice(-6);
            return <p className="m-0">{lastFourDigits}</p>;
          }
        },
      },
//             {
//   Header: "U-ID",
//   accessor: "user_id.local_uid",
//   Cell: ({ row }) => {
//     const userId = row.original?.user_id?.local_uid;

//     // Handle null, undefined, empty string, or whitespace
//     const displayValue =
//       userId == null || String(userId).trim() == "" ? "--" : userId;

//     return <p className="PTAGs">{displayValue}</p>;
//   },
// },
  {
      Header: "Employee Code",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              className="UserName"
              style={{ cursor: "pointer" }}
            >
              <div className="">
                <span>
                  {row.row.original.user_id?.user_uid != null &&
                  row.row.original.user_id?.user_uid != undefined &&
                  row.row.original.user_id?.user_uid != ""
                    ? row.row.original.user_id?.user_uid
                    : "--"}
                </span>
              </div>
            </div>
          </>
        );
      },
    },
      {
      Header: filterForWhite.white_collar ? "User Name" : "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.user_id.first_name ? (
              <span>{row.row.original.user_id.first_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Branch",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.client_id != undefined &&
            row.row.original.client_id.client_name != undefined ? (
              <span>{row.row.original.client_id.client_name}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },
    {
      Header: "Month",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.month != undefined ? (
              <span>{row.row.original.month}</span>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;
        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Slip",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.slip_url != undefined &&
            row.row.original.slip_url != null &&
            row.row.original.slip_url.media_url != undefined ? (
              // {row.row.original.slip_url.media_url}

              <button
                onClick={(e) => {
                  e.stopPropagation();
                window.open(row.row.original.slip_url.media_url, "_blank");

                }}
                // href={row.row.original.slip_url.media_url}
                download
                target="_blank"
                style={{
                  background: "#E2F4DD",
                  padding: "0.375rem 0.75rem",
                  borderRadius: "4px",
                  color: "green",
                }}
                className="DownloadImage DownloadImageBtn"
              >
                {/* <i
                  class="fa-solid fa-download"
                  style={{ marginRight: "5px" }}
                  onClick={(e) => download(e)}
                ></i> */}
                   <span  className="SlipEditImage">
                   <img src={DownloadImage}/>
                </span>
                view
              </button>
            ) : (
              <span>{"Not Uploaded"}</span>
            )}
          </>
        );
      },
    },
    // {
    //   Header: "Status",
    //   accessor: "status",
    //   Cell: (row) => {
    //     const originalString = row.row.original.status;
    //     const capitalizedString = capitalizeFirstLetter(originalString);
    //     return (
    //       <>
    //         {row.row.original.status != undefined ? (
    //           <>
    //             {row.row.original.status.toLowerCase() == "pending" ? (
    //               <div className="StatusList">
    //                 <img src={Pendingimg} />
    //                 <span>{capitalizedString}</span>
    //               </div>
    //             ) : (
    //               <>
    //                 {row.row.original.status.toLowerCase() == "decline" ? (
    //                   <div className="StatusList">
    //                     <div className="DeclineStatus">
    //                       <span>x</span>
    //                     </div>
    //                     <span>{capitalizedString}</span>
    //                   </div>
    //                 ) : (
    //                   <>
    //                     {row.row.original.status.toLowerCase() == "approved" ? (
    //                       <div className="StatusList">
    //                         <img src={correctIcons} />
    //                         <span>{capitalizedString}</span>
    //                       </div>
    //                     ) : null}
    //                   </>
    //                 )}
    //               </>
    //             )}
    //           </>
    //         ) : (
    //           <span>---</span>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      Header: "Actions",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
             

              <button
                type="button"
                class="btn Status"
                onClick={(e) => {
                  setDeleteID(row.row.original.id);
                  setDeletePOPUP(true);
                }}
              >
                <span className="OuterActionSpan">
                <span  className="EditImages">
                    <img src={DeleteImages}/>
                  </span>
                  <span className="ActionsList"> Delete </span>
                </span>
              </button>
            </div>
          </>
        );
      },
    },
  ],
  [sno]
    );
  const HandleSubmits = () => {
    if (DeleteID != undefined) {
      const payload = {
        DeleteID: DeleteID,
        currentPage: dtpageindex,
        // selectVal: selectVal,
        month: Data.month,
        year: Data.year,
        white_collar: filterForWhite.white_collar,
      };
      dispatch(setThePayslipDeleteActions(payload, setDeletePOPUP(false)));
    }
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    //console.log(SelectedValues, "selectedvaluess");
    setDisplay(SelectedValues);
    setSelected(sel);
    SetStates(true);
    dispatch(setTheoptions(SelectedValues));
    dispatch(setThecountBasedRenders(2));
    setdtPageindex(1);

    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,
        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        is_decline: true,
        is_pending: "",
        approved: "",
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "ALL") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  let objectArray = [];
  //console.log(state.NumberCounts.namerednder, "names");
  options.map((item) => {
    if (item.value == 1 && state.NumberCounts.namerednder == "") {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Payslip</h3>

          </div>
          <div className="Add-User col-sm-5">
            <button
              onClick={(e) => {
                setRoleCreatePopup(true);
                setEditID("");
              }}
              className="ButtonCSS"
            >
              {" "}
              Create{" "}
            </button>
          </div>
        </div>
<br/>
        <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
          {/* <div style={{display:"flex",justifyContent:"flex-end", position:"relative", top:"85px", zIndex:"1", justifyContent:"space-around", alignItems:"center"}}>
  <div></div>
  <div class="col-sm-2 field-div" style={{position:"relative", top:"-11px", display:"flex", justifyContent:"flex-end", flexDirection:"column"}}>
                          <label
                            for="validationCustom02"
                            class="form-label"
                            style={{ fontSize: "15px" }}
                          >
                            Employee Role
                          </label>


                          <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onChange={(e) => {
                              HandleEMprole(e);
                            
                            }}
                            value={EMpROleSelected}
                            options={EmpRoles}
                            placeholder="search"
                          />


                        </div>
                        </div> */}

          <ReactTable
            data={state.payslip.PaySlipData}
            columns={columns}
            totalItems={state.payslip.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}
          dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            pageindex={pageindex}
            datacount={state.payslip.Total_Count}
            // value={state.NumberCounts.Options}
            // options={options}
            Filter={Filter}
            //---to remove the status filter
            nostatusFilter={true}
            // count={count}
            // ClearState={ClearState}
            // placeHold={place}
            ///--- emoloyee role based filters -
            EmployeeRoleTrue={true}
            EmployeeRoleOption={EmpRoles}
            EMpROleSelected={state.StateManagementOverallCall.PaySlipDesignations}
            HandleEMprole={HandleEMprole}
            //---Month based filter
            MonthFilter={true}
            yearAndMonth={yearAndMonth}
            handleChange={handleChange}
          />
        </div>
      </div>

      {RoleCreatePopup ? (
        <PaySlipCreate
          setShow={setRoleCreatePopup}
          show={RoleCreatePopup}
          EditId={EditId}
          currentPage={dtpageindex}
          white_collar={filterForWhite.white_collar}
          Datamonths={Data}
          search={search}
        />
      ) : null}

      {DeletePOPUP ? (
        <Delete
          show={DeletePOPUP}
          setShow={setDeletePOPUP}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete the Payslip"}

        />
      ) : null}
    </>
  );
};

export default PaySlip;
